// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.32816 3.32813 3.99481 5.99479H1.32812V9.99479H3.99481L7.32816 12.6615 7.32816 3.32813ZM12.7127 3.28906C13.9625 4.53925 14.6646 6.23463 14.6646 8.0024 14.6646 9.77016 13.9625 11.4655 12.7127 12.7157M10.3594 5.6424C10.9843 6.26749 11.3353 7.11518 11.3353 7.99906 11.3353 8.88294 10.9843 9.73064 10.3594 10.3557"
    />
  </svg>
);
const IconVolume = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconVolume;
